import React from 'react';
function TableImage(props) {
     
    return (<> <img className='rounded-circle' 
                    width="40px" 
                    height="40px" 
                    src={props.directory ? `https://cdn.abyedh.com/Images/Search/CIconsS/${props.image}` : `https://cdn.abyedh.com/images/system/${props.image}`} alt="user-img" 
                /> </>);
}

export default TableImage